import axios from '../utils/request';
import { AxiosRequestConfig } from 'axios';
import { IObject, IResponse } from '../constants/interface';

/** POST */
function POST(
  url: string,
  params: IObject = {},
  otherConfig?: AxiosRequestConfig,
): Promise<IResponse> {
  return axios.post(url, params, { ...otherConfig });
}

export default POST;
